import React from "react";

import { Description } from "./AtDescription";

export default function AtDescription({ children, ...rest }) {
  return <Description {...rest}>{children}</Description>;
}
